const preloadState = window.__litium.preloadState || {};

let initialState = {
    activeChannelId: preloadState.activeChannelId
}

export const channel = (state = initialState, action) => {
    switch (action.type) {
        case "CHANNEL_UPDATE":
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};
